import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ar from './locales/ar.json'
import en from './locales/en.json'
Vue.use(VueI18n)
const messages = {
	en: en,
	ar: ar 
}
const defaultLang = localStorage.getItem('lang') || 'ar'
document.documentElement.setAttribute('dir', defaultLang === 'ar' ? 'rtl' : 'ltr');
document.documentElement.setAttribute('lang', defaultLang);
const i18n = new VueI18n({
	locale: defaultLang, // Default language
	fallbackLocale: 'ar',
	messages
})

export default i18n
